/**
 * Klasa zarządzająca adaptacyjną jakością renderowania
 */
export class AdaptiveQuality {
    constructor(config = {}) {
        this.enabled = config.enabled !== false;
        this.targetFPS = config.targetFPS || 50;
        this.minFPS = config.minFPS || 30;
        this.checkInterval = config.checkInterval || 60;
        this.frameCount = 0;
        this.fpsHistory = [];
        this.fpsHistorySize = config.fpsHistorySize || 10;
        this.baseResolutionScale = config.baseResolutionScale || 1.0;
        this.currentResolutionScale = config.baseResolutionScale || 1.0;
        this.stepSize = config.stepSize || 0.1;
        
        // FPS tracking
        this.lastFrameTime = null;
        this.frameTimes = [];
        this.lastFPS = 60;
    }
    
    /**
     * Oblicz FPS używając własnego licznika
     */
    calculateFPS() {
        const currentTime = performance.now();
        
        if (!this.lastFrameTime) {
            this.lastFrameTime = currentTime;
            this.frameTimes = [];
            this.lastFPS = 60;
            return 60;
        }
        
        const frameTime = currentTime - this.lastFrameTime;
        this.lastFrameTime = currentTime;
        
        this.frameTimes.push(frameTime);
        if (this.frameTimes.length > 60) {
            this.frameTimes.shift();
        }
        
        const avgFrameTime = this.frameTimes.reduce((a, b) => a + b, 0) / this.frameTimes.length;
        const fps = 1000 / avgFrameTime;
        this.lastFPS = Math.round(fps * 10) / 10;
        
        return this.lastFPS;
    }
    
    /**
     * Aktualizacja jakości na podstawie FPS
     * Zwraca true jeśli jakość się zmieniła
     */
    update() {
        if (!this.enabled) {
            return false;
        }
        
        this.frameCount++;
        
        if (this.frameCount < this.checkInterval) {
            return false;
        }
        
        this.frameCount = 0;
        
        const currentFPS = this.lastFPS || 60;
        
        this.fpsHistory.push(currentFPS);
        if (this.fpsHistory.length > this.fpsHistorySize) {
            this.fpsHistory.shift();
        }
        
        const avgFPS = this.fpsHistory.reduce((a, b) => a + b, 0) / this.fpsHistory.length;
        
        const oldResolutionScale = this.currentResolutionScale;
        const minScale = 0.1;
        const maxScale = 1.0;
        
        if (avgFPS < this.minFPS) {
            const newScale = Math.max(minScale, this.currentResolutionScale - this.stepSize);
            if (newScale !== this.currentResolutionScale) {
                this.currentResolutionScale = newScale;
                console.log(`[Adaptive Quality] FPS: ${avgFPS.toFixed(1)} - Obniżono jakość: ${oldResolutionScale.toFixed(2)} → ${newScale.toFixed(2)}`);
            }
        } else if (avgFPS > this.targetFPS + 5) {
            const newScale = Math.min(
                this.baseResolutionScale, 
                this.currentResolutionScale + this.stepSize
            );
            if (newScale !== this.currentResolutionScale && newScale <= maxScale) {
                this.currentResolutionScale = newScale;
                console.log(`[Adaptive Quality] FPS: ${avgFPS.toFixed(1)} - Podniesiono jakość: ${oldResolutionScale.toFixed(2)} → ${newScale.toFixed(2)}`);
            }
        }
        
        return oldResolutionScale !== this.currentResolutionScale;
    }
}

